// extracted by mini-css-extract-plugin
export default {"fieldAmount":"styles_fieldAmount__mVQ3P","contentSubmit":"styles_contentSubmit__d-qYq"};